import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import SecureLS from 'secure-ls'

// Modules
import common from './modules/common'
import events from './modules/events'
import faq from './modules/faq'
import global_search from './modules/global_search'
import library from './modules/library'
import news from './modules/news'
import notifications from './modules/notifications'
import params from './modules/params'
import redirect from './modules/redirect'
import site_lists from './modules/site_lists'
import user from './modules/user'
import reward_store from './modules/reward_store'
import welcome_banner from './modules/welcome_banner'
import cookies_policy from './modules/cookies_policy'

const ls = new SecureLS({ isCompression: false })
const dataState = createPersistedState({
  key: process.env.PROJECT_FOLDER,
  storage: {
    getItem: (key) => ls.get(key),
    setItem: (key, value) => ls.set(key, value),
    removeItem: (key) => ls.remove(key),
  },
  paths: ['common', 'params', 'site_lists', 'welcome_banner', 'cookies_policy'],
})

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    common,
    events,
    faq,
    global_search,
    library,
    news,
    notifications,
    params,
    redirect,
    site_lists,
    user,
    reward_store,
    welcome_banner,
    cookies_policy,
  },
  plugins: [dataState],
})
